export class AgentLegEvent {
  constructor(json) {
    this.type = json.Type;
    this.agentLegId = json.AgentLegId;
    this.status = json.Status;
  }

  get description() {
    return `${this.type} #${this.agentLegId} -> ${this.status}`;
  }
}
